import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import ConfigBranch from '../../../../components/modules/master/config-branch';
import ConfigBranchMiddleware from '../../../../middleware/modules/master/config-branch';
import i18n from '../../../../i18n';
import { Helmet } from 'react-helmet';
// middlewares


const mapStateToProps = ({ auth,configBranch }) => ({
  isProcessing: configBranch.isProcessing,
  isError: configBranch.isError,
  errorMessage: configBranch.errorMessage,
  datalist:configBranch.data,
  showModalConfig:configBranch.showModalConfig
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    create: () =>ConfigBranchMiddleware.create(),
    reset: () =>ConfigBranchMiddleware.resetList(),
    search: data =>ConfigBranchMiddleware.list(data),
    update: data =>ConfigBranchMiddleware.update(data),
    delete: (id,search) =>ConfigBranchMiddleware.beforeDelete(id,search),
  }, dispatch);
};
class ConfigBranchContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
   this.props.reset();
   this.props.search(search);
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    
    this.props.update(id)
  }
  createItem(){
    this.props.create()
  }
  render() {
    const {isProcessing, search , datalist,showModalConfig} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Config Branch List")}
          </title>
        </Helmet>
      <ConfigBranch
        {...this.props}
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModalConfig={showModalConfig}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfigBranchContainer);
